import src from "IMAGE";
export default { src, width: 205, height: 169, blurWidth: 0, blurHeight: 0};
